<template>
  <div>
    <div class="badge badge-secondary" v-if="status==='AssignedToEvaluator'">
      {{$t("realEstate.status.assignedToEvaluator")}}
    </div>
    <div class="badge badge-warning" v-else-if="status==='NotFullyEvaluated'">
      {{$t("realEstate.status.notFullyEvaluated")}}
    </div>
    <div class="badge badge-info" v-else-if="status==='Evaluated'">
      {{$t("realEstate.status.evaluated")}}
    </div>
    <div class="badge badge-success" v-else-if="status==='Confirmed'">
      {{$t("realEstate.status.confirmed")}}
    </div>
    <div class="badge badge-danger" v-else-if="status==='Rejected'">
      {{$t("realEstate.status.rejected")}}
    </div>
    <div class="badge badge-warning" v-else-if="status==='NotReady'">
      {{$t("realEstate.status.notReady")}}
    </div>
    <div class="badge badge-secondary" v-else-if="status==='Pending'">
      {{$t("realEstate.status.pending")}}
    </div>
    <div class="badge badge-success" v-else-if="status==='InIdentification'">
      {{$t("realEstate.status.inIdentification")}}
    </div>
    <div class="badge badge-warning" v-else-if="status==='Open'">
      {{$t("realEstate.status.open")}}
    </div>
    <div class="badge badge-dark" v-else-if="status==='InCorrection'">
      {{$t("realEstate.status.inCorrection")}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  name: "RealEstateStatus"
}
</script>

<style scoped>

</style>